import { func, string } from "prop-types"
import { useCallback } from "react"
import { useDropzone } from "react-dropzone"
import styled from "styled-components"

const Container = styled.div`
    color: white;
    height: 100%;
    width: 100%;
    opacity:${p => p.isDragActive ? 0.4 : 1};
    margin: 0;
    padding: 0;
    box-sizing: content-box;
    display: flex;
    align-items: center;
    justify-content: center;

`

const ACCEPT = "image/png"

const Uploader = ({ onChange }) => {
  const onDrop = useCallback((files, rejected, event) => {
    const file = files[0]

    console.log("file", file)
    const reader = new FileReader()

    // reader.onabort = () => console.log("file reading was aborted")
    reader.onerror = (err) => console.log("file reading has failed", err)
    reader.onload = () => {
      const preview = reader.result
      onChange(preview)
    }

    if (file) {
      reader.readAsDataURL(file)
    }
  }, [])
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: ACCEPT,
  })

  return <Container {...getRootProps()} isDragActive={isDragActive}>
    <input
      {...getInputProps()}
      name="uploader"
    />
    <p>Drag or Upload Your Logo</p>
  </Container>
}

Uploader.propTypes = {
  onChange: func,
  preview: string,
}

export default Uploader
